module.exports = __webpack_public_path__ + "images/game/xmas-pattern-gifts-balls.8f01ca0b59b35eb2cd135aad247bbeaf.png";